import React from "react";
import HomeCarousel from "../customer/Components/Carousel/HomeCarousel";
import { homeCarouselData } from "../customer/Components/Carousel/HomeCaroselData";
import HomeProductSection from "../customer/Components/Home/HomeProductSection";
import { electronicPage2 } from "../Data/Electronic/electronicPage2";
import { kids } from "../Data/kids";
import { mensShoesPage1 } from "../Data/shoes";
import { accessories } from "../Data/accessories";
import { mens_kurta } from "../Data/Men/men_kurta";
import { lengha_page1 } from "../Data/Women/LenghaCholi";

const Homepage = () => {

  return (
    <div className="">
      <HomeCarousel images={homeCarouselData} />

      <div className="space-y-10 py-20">
      <HomeProductSection data={mens_kurta} section={"Men's Wear"} />
        <HomeProductSection data={mensShoesPage1} section={"Shoes"} />
        {/* <HomeProductSection data={lengha_page1} section={"Womens Wear"} />
        <HomeProductSection data={accessories} section={"Accesories"} />
        <HomeProductSection data={kids} section={"Kids Wear"} />
        <HomeProductSection data={electronicPage2} section={"Electronics"} /> */}
      </div>

      
    </div>
  );
};

export default Homepage;
